import React, { useEffect, useState } from 'react';
import { Users, FileText, Calendar, BarChart3, UserPlus, ClipboardList } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import accountApi from '../api/accountApi';
import { setAccountDetails, setAllWorkflowTemplates } from '../store/accounts/Account';
import workflowApi from '../api/workflowApi';
import leadApi from '../api/leadApi';
import taskApi from '../api/taskApi';
import meetingApi from '../api/meetingApi';
import DashboardReport from '../pages/dashboard/DashboardReport';

export const Dashboards = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.access_token);
    const [totalClients, setTotalClients] = useState(0);
    const [totalLeads, setTotalLeads] = useState(0);
    const [totalTaks, setTotalTaks] = useState(0);
    const [totalUpcomingMeetings, setTotalUpcomingMeetings] = useState(0);
    const [upcomingMeetings, setUpcomingMeetings] = useState([]);
    const [upcomingDueDates, setUpcomingDueDates] = useState([]);


//     useEffect(() => {
//         const fetchAccounts = async () => {
//             try {
//                 const { data } = await accountApi.getAllAccounts(token);

//                 const accounts = data.content
//                 const upcomingDueDate = accounts.flatMap(account =>
//     (account.tasks || []).map(task => ({
//         client: account.accountName,
//         return: task.title,
//         dueDate: task.dueDate,
//         status: task.status
//     }))
// );
// setUpcomingDueDates(upcomingDueDate)
//                 const workflowTemplates = await workflowApi.getAllWorkflowTemplates(token);

//                 dispatch(setAccountDetails(data.content));
//                 dispatch(setAllWorkflowTemplates(workflowTemplates.data));
//                 setTotalClients(data.totalElements)

//                 const lead= await leadApi.getAllLeads(token)
// setTotalLeads(lead.data.length)
// const response = await taskApi.getAllTasks(token);
// setTotalTaks(response.data.length)

// const meeting = await meetingApi.getAllMeetings(token, 1, 1000);
// console.log("meeting====>",meeting)
// const today = new Date();

// const upcomingMeeting = meeting.data.filter(item =>{
//     const meetingDate = new Date(item.meetingDate);
//     return meetingDate >= today
// })
// setTotalUpcomingMeetings(upcomingMeeting.length)
// setUpcomingMeetings(upcomingMeeting)

//                 if (!data || !data.content) {
//                     toast.error('Invalid response from server');
//                     return;
//                 }

//             } catch (error) {
//                 console.error("Error fetching accounts:", error);
//             }
//         };

//         fetchAccounts();
//     }, [token]);


useEffect(() => {
  const fetchAccounts = async () => {
    try {
      const [
        accountsRes,
        workflowsRes,
        leadsRes,
        tasksRes,
        meetingsRes
      ] = await Promise.allSettled([
        accountApi.getAllAccounts(token),
        workflowApi.getAllWorkflowTemplates(token),
        leadApi.getAllLeads(token),
        taskApi.getAllTasks(token),
        meetingApi.getAllMeetings(token, 1, 1000),
      ]);
      if (accountsRes.status === "fulfilled") {
        const data = accountsRes.value.data;

        dispatch(setAccountDetails(data.content));
        setTotalClients(data.totalElements);

        const upcomingDueDate = data.content.flatMap(account =>
          (account.tasks || []).map(task => ({
            client: account.accountName,
            return: task.title,
            dueDate: task.dueDate,
            status: task.status,
          }))
        );
        setUpcomingDueDates(upcomingDueDate);
      }

      if (workflowsRes.status === "fulfilled") {
        dispatch(setAllWorkflowTemplates(workflowsRes.value.data));
      }

      if (leadsRes.status === "fulfilled") {
        setTotalLeads(leadsRes.value.data.length);
      }

      if (tasksRes.status === "fulfilled") {
        setTotalTaks(tasksRes.value.data.length);
      } else {
        console.warn("Tasks not found");
        setTotalTaks(0);
      }

      if (meetingsRes.status === "fulfilled") {
        const meetings = meetingsRes.value.data;
        const today = new Date();

        const upcomingMeeting = meetings.filter(item => {
          const meetingDate = new Date(item.meetingDate);
          return meetingDate >= today;
        });

        setTotalUpcomingMeetings(upcomingMeeting.length);
        setUpcomingMeetings(upcomingMeeting);
      }

    } catch (error) {
      console.error("Unexpected error:", error);
    }
  };

  fetchAccounts();
}, [token]);

    const dashboardData = {
        totalClients: totalClients,
        totalLeads: totalLeads,
        totalTaks: totalTaks,
        totalUpcomingMeetings: totalUpcomingMeetings,
        upcomingMeetings: upcomingMeetings,
        upcomingDueDates: upcomingDueDates,
        recentActivity: [
            { action: 'Filed GSTR-1', client: 'ABC Industries', time: '2 hours ago' },
            { action: 'Invoice uploaded', client: 'XYZ Corp', time: '4 hours ago' },
            { action: 'New client added', client: 'Tech Solutions', time: '1 day ago' }
        ]
    };

    const quickActions = [
        {
            id: 'add-client',
            title: 'Add New Client',
            description: 'Onboard a new client company',
            icon: Users,
            color: 'bg-blue-50 text-blue-700 hover:bg-blue-100',
            action: () => {
                navigate('/accounts/createAccounts');
            }
        },
        {
            id: 'create-invoice',
            title: 'Create Invoice',
            description: 'Generate client service invoice',
            icon: FileText,
            color: 'bg-green-50 text-green-700 hover:bg-green-100',
            action: () => {
                navigate('/invoice-generator');
            }
        },
        {
            id: 'view-reports',
            title: 'View Reports',
            description: 'Access analytics and reports',
            icon: BarChart3,
            color: 'bg-purple-50 text-purple-700 hover:bg-purple-100',
            action: () => {
                navigate('/reports');
            }
        },
        {
            id: 'schedule-filing',
            title: 'Create Tasks',
            description: 'Plan upcoming return filings',
            icon: Calendar,
            color: 'bg-orange-50 text-orange-700 hover:bg-orange-100',
            // action: () => setShowScheduleModal(true)
            action: () => navigate('/tasks/createTasks')
        }
    ];

   const statCards = [
    {
        title: 'Total Clients',
        value: dashboardData.totalClients,
        icon: Users,
        bgColor: 'bg-blue-50',
        textColor: 'text-blue-600',
        // url: '/clients'
    },
    {
        title: 'Total Leads',
        value: dashboardData.totalLeads,
        icon: UserPlus,
        bgColor: 'bg-green-50',
        textColor: 'text-green-600',
        // url: '/leads'
    },
    {
        title: 'Total Active Tasks',
        value: dashboardData.totalTaks,
        icon: ClipboardList,
        bgColor: 'bg-purple-50',
        textColor: 'text-purple-600',
        // url: '/tasks'
    },
    {
        title: 'Upcoming Meetings',
        value: dashboardData.totalUpcomingMeetings,
        icon: Calendar,
        bgColor: 'bg-orange-50',
        textColor: 'text-orange-600',
        // url: '/meetings'
    }
];


    return (
        <div className="space-y-6">
            {/* <div className="bg-primary rounded-lg px-6 py-2 text-white">
                <h1 className="text-2xl font-bold mb-2">Welcome back, {userData.fullName} !</h1>
                <p className="text-blue-100">Here's what's happening with your clients today.</p>
            </div> */}

            {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {statCards.map((card, index) => (
                    <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 px-3 py-2">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm font-medium text-gray-600">{card.title}</p>
                                <p className="text-2xl font-bold text-gray-900">{card.value || 0}</p>
                            </div>
                            <div className={`${card.bgColor} p-3 rounded-full`}>
                                <card.icon className={`h-6 w-6 ${card.textColor}`} />
                            </div>
                        </div>
                    </div>
                ))}
            </div> */}

            {/* <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 ">
                <div className="max-h-[400px] overflow-auto lg:col-span-2 bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <div className="flex items-center justify-between mb-4">
                        <h3 className="text-lg font-semibold text-gray-900">Upcoming Due Dates</h3>
                        <Calendar className="h-5 w-5 text-gray-400" />
                    </div>
{dashboardData.upcomingDueDates.length > 0 ? (
  <div className="space-y-3">
                        {dashboardData.upcomingDueDates.map((item, index) => (
                            <div key={index} className="flex items-center justify-between px-3 py-1 border-1 border-gray-100 rounded-lg">
                                <div>
                                    <p className="font-medium text-gray-900">{item.client}</p>
                                    <p className="text-sm text-gray-500">{item.return} - Due: {item.dueDate}</p>
                                </div>
                                <span className={`px-3 py-1 rounded-full text-xs font-medium  ${getStatusColor(item.status)}`}>
                                    {item.status}
                                </span>
                            </div>
                        ))}
                    </div>
):"Not Upcoming Due Dates"}
                  
                </div>

             <div className="max-h-[400px] overflow-auto bg-white rounded-lg shadow-sm border border-gray-200 p-6">
    <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Upcoming Meetings
    </h3>

{dashboardData.upcomingMeetings.length > 0 ?(
<div className="space-y-4">
        {dashboardData.upcomingMeetings.map((meeting, index) => {
            const dateObj = new Date(meeting.meetingDate);

            const formattedDate = dateObj.toLocaleDateString();
            const formattedTime = dateObj.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            }) || "00:00";

            return (
                <div key={index} className="flex items-start space-x-3">

                    <div className='min-w-full px-3 py-1 border-1 border-gray-100 rounded-lg'>
                        <p className="text-sm font-medium text-gray-900">
                            {meeting.meetingType.replace(/_/g, ' ')}
                        </p>

                        <p className="text-sm text-gray-500">
                            {formattedDate} at {formattedTime}
                        </p>

                        <p className="text-xs text-gray-400">
                            Members: {meeting.presentMembers}
                        </p>
                    </div>
                </div>
            );
        })}
    </div>
):"No any Upcoming Meetings"}
    
</div>

            </div> */}

            <DashboardReport/>
{/* 
            <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Quick Actions</h3>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                    {quickActions.map((action) => (
                        <button
                            key={action.id}
                            onClick={action.action}
                            className={`flex flex-col items-center space-y-2 px-4 py-1 rounded-lg transition-colors ${action.color}`}
                        >
                            <action.icon className="h-6 w-6" />
                            <div className="text-center">
                                <span className="font-medium">{action.title}</span>
                                <p className="text-xs opacity-75 mt-1">{action.description}</p>
                            </div>
                        </button>
                    ))}
                </div>
            </div> */}

            {/* {showScheduleModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">Schedule Filing</h3>

                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Client</label>
                                <select className="w-full px-3 py-2 border border-gray-300 rounded-md">
                                    <option value="">Select Client</option>
                                    <option value="abc">ABC Industries</option>
                                    <option value="xyz">XYZ Corp</option>
                                    <option value="tech">Tech Solutions</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Return Type</label>
                                <select className="w-full px-3 py-2 border border-gray-300 rounded-md">
                                    <option value="">Select Return Type</option>
                                    <option value="gstr1">GSTR-1</option>
                                    <option value="gstr3b">GSTR-3B</option>
                                    <option value="gstr9">GSTR-9 (Annual)</option>
                                    <option value="tds">TDS Return</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Due Date</label>
                                <input type="date" className="w-full px-3 py-2 border border-gray-300 rounded-md" />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Assigned To</label>
                                <select className="w-full px-3 py-2 border border-gray-300 rounded-md">
                                    <option value="">Select Team Member</option>
                                    <option value="john">John Doe</option>
                                    <option value="jane">Jane Smith</option>
                                    <option value="mike">Mike Johnson</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
                                <select className="w-full px-3 py-2 border border-gray-300 rounded-md">
                                    <option value="medium">Medium</option>
                                    <option value="high">High</option>
                                    <option value="low">Low</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
                                <textarea
                                    rows={3}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                                    placeholder="Additional notes or requirements..."
                                />
                            </div>
                        </div>

                        <div className="flex space-x-3 mt-6">
                            <button
                                onClick={() => {
                                    alert('Filing scheduled successfully!');
                                    setShowScheduleModal(false);
                                }}
                                className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                            >
                                Schedule Filing
                            </button>
                            <button
                                onClick={() => setShowScheduleModal(false)}
                                className="flex-1 bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )} */}
        </div>
    );
};


// import React from 'react'
// import DashboardReport from '../pages/dashboard/DashboardReport';

// export const Dashboards = () => {
//   return (
//     <DashboardReport/>
//   )
// }

